import type { LayoutLoad } from './$types';
import { getPicks } from '$lib/services/videos';

export const load: LayoutLoad = async ({ parent }) => {
	const { balancedSupabase } = await parent();

	const [picks] = await Promise.all([getPicks(balancedSupabase)]);

	return {
		picks
	};
};
